import { Search } from "lucide-react";
import React from "react";

type SearchFieldProps = {
    purpose: string,
    placeholder: string,
    onSearchClick: () => void,
    searchField: string,
    setSearchField: (field: string) => void;
}
export default function SearchField({ purpose, placeholder, onSearchClick, searchField, setSearchField } : SearchFieldProps){
    
    return (
        <div className="max-w-2xl flex mx-auto my-3">
            <input onKeyDown={(e) => e.key === "Enter" && onSearchClick()} onChange={(e) => setSearchField(e.target.value)} type="text" placeholder={placeholder} value={searchField} className="flex-1 w-full border rounded-xl border-gray-300 focus:ring-purple-500 focus:border-purple-500 px-4 py-2" name={purpose} id={purpose} />
            <button onClick={onSearchClick} className="bg-[var(--primary-color)] text-white p-2 rounded-full"><Search /></button>
        </div>
    )
}